<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(color="primary")
  v-container(fluid)
    v-row(justify="center" align="center")
      v-col(cols="auto")
        v-row(justify="center" align="center")
          v-col.text-start.text-md-center(cols="auto")
            h2.mb-6.mb-md-8.ibm.text-h3.text-md-h2.font-weight-regular.white--text Quer testar o Erudio na prática?
            .heebo.text-h6.text-md-h5.font-weight-regular.white--text Faça um teste 100% gratuito e sem cartão de crédito!
        v-row(justify="center" align="center")
          v-col(cols=12 md="auto")
            v-btn.mt-4.mt-md-8.px-md-16.heebo.primary--text.text-body-1.font-weight-medium.text-none(
              color="white"
              depressed
              :block="$vuetify.breakpoint.smAndDown"
              height=56
              @click="$goTo({ path: '/', target: '#selectInst' })"
            ) Começar teste gratuito!
</template>

<script>
export default {
  components: {},
  data() {
    return {
      cards: [
        {
          id: 0,
          image: '',
          title: 'IEPSIS',
          subtitle: 'Descrição da empresa',
          action: () => {}
        },
        {
          id: 1,
          image: '',
          title: 'IEPSIS',
          subtitle: 'Descrição da empresa',
          action: () => {}
        },
        {
          id: 2,
          image: '',
          title: 'IEPSIS',
          subtitle: 'Descrição da empresa',
          action: () => {}
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped></style>
